export default "__VITE_ASSET__3454b91c__"